import { render, staticRenderFns } from "./lottery_config.vue?vue&type=template&id=23a793ef&scoped=true"
import script from "./lottery_config.vue?vue&type=script&lang=js"
export * from "./lottery_config.vue?vue&type=script&lang=js"
import style0 from "./lottery_config.vue?vue&type=style&index=0&id=23a793ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a793ef",
  null
  
)

export default component.exports